import {
  endOfMonth,
  endOfYear,
  startOfMonth,
  startOfYear,
  sub,
} from "date-fns";

import { DateRangePreset } from "@components/DatePicker/Range";

const TODAY = new Date();

export const MENTION_VIEW_DATE_RANGES: DateRangePreset[] = [
  {
    startDate: sub(TODAY, { hours: 24 }),
    endDate: TODAY,
    label: L.LATEST_24_HOURS,
    identifier: "last_24_hours",
  },
  {
    startDate: sub(TODAY, { days: 7 }),
    endDate: TODAY,
    label: L.LAST_7_DAYS,
    identifier: "last_7_days",
  },
  {
    startDate: sub(TODAY, { days: 30 }),
    endDate: TODAY,
    label: L.LAST_30_DAYS,
    identifier: "last_30_days",
  },
  {
    startDate: startOfMonth(TODAY),
    endDate: TODAY,
    label: L.DATE_THIS_MONTH,
    identifier: "this_month",
  },
  {
    startDate: startOfMonth(sub(TODAY, { months: 1 })),
    endDate: endOfMonth(sub(TODAY, { months: 1 })),
    label: L.DATE_PREVIOUS_MONTH,
    identifier: "previous_month",
  },
  {
    startDate: startOfYear(TODAY),
    endDate: TODAY,
    label: L.THIS_YEAR,
    identifier: "this_year",
  },
  {
    startDate: startOfYear(sub(TODAY, { years: 1 })),
    endDate: endOfYear(sub(TODAY, { years: 1 })),
    label: L.PREVIOUS_YEAR,
    identifier: "previous_year",
  },
  {
    startDate: sub(TODAY, { months: 3 }),
    endDate: TODAY,
    default: true,
    label: L.LATEST_3_MONTHS,
    identifier: "last_3_months",
  },
];
